// The Floor layout (tablet first): what a technician uses at the bench. MIST's
// workspace bar without the drawer, which a 1024px tablet can't spare, so the
// brand rides in the bar. It always shows the station and who is signed in (T1).
import { useId } from 'react';
import { Link, Outlet } from 'react-router';

import { Button } from '../design/components';
import { StationPicker } from '../features/station/StationPicker';
import { useStation } from '../features/station/useStation';
import { AppBar } from './AppBar';

export function FloorLayout() {
    const [station, setStation] = useStation();
    const stationLabel = useId();
    return (
        <div className="sf-app sf-app--floor">
            <AppBar workspace="Shop floor" brandHome="/floor">
                {station ? (
                    <>
                        <span className="sf-appbar-divider" aria-hidden="true" />
                        <div className="sf-workspace" role="group" aria-labelledby={stationLabel}>
                            <span className="eyebrow sf-workspace-label" id={stationLabel}>
                                Station
                            </span>
                            <span className="text-md sf-workspace-title">{station}</span>
                        </div>
                        <Button
                            variant="text"
                            onClick={() => {
                                setStation(null);
                            }}
                        >
                            Change station
                        </Button>
                        <Link to="/lead" className="sf-button sf-button--text">
                            Lead view
                        </Link>
                    </>
                ) : null}
            </AppBar>
            <main className="sf-page" id="main">
                {station ? <Outlet context={station} /> : <StationPicker onPick={setStation} />}
            </main>
        </div>
    );
}
